import Routes from "core/components/routing/routes";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import "App.css";
import { GlobalStyles } from "core/styles/global.styled";
import * as theme from "core/styles/theme";
import { AppThemeProvider, useAppTheme } from "core/contexts/theme/theme";

function AppContent() {
  const { apptheme }: any = useAppTheme();

  if (!apptheme) return null;

  return (
    <StyledThemeProvider theme={apptheme}>
      <GlobalStyles theme={apptheme} />

      <MUIThemeProvider
        theme={apptheme.name === "dark-theme" ? theme.darkTheme : theme.lightTheme}
      >
          <Routes />

      </MUIThemeProvider>
    </StyledThemeProvider>
  );
}

function App() {
  return (
    <AppThemeProvider>
      <AppContent />
    </AppThemeProvider>
  );
}

export default App;
